import { render, staticRenderFns } from "./RightFourth.vue?vue&type=template&id=335610ff"
import script from "./RightFourth.vue?vue&type=script&lang=js"
export * from "./RightFourth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports